// Batch 31 · items 20 + 31 — cash-flow helpers for IFRS.jsx (that page is over 1,500 lines: new code lives here — the project's frozen-files rule §7).
import React from "react";
import { asArray } from "@/lib/asArray";
import { useI18n } from "@/contexts/I18nContext";

// item 31: the line's own label in the screen language (the engine gives label_ar on every cash-flow line)
export function cfLabel(line, lang) {
  return (lang === "ar" && line?.label_ar) || line?.label || "";
}

// item 31: the current-year lines with the prior-year line of the same key next to them. A line the engine shows in one
// year only (disposal proceeds, a write-off) no longer pushes the prior-year figures one row down; a prior-year-only line is
// listed after the current-year lines of its section. Lines without a key (an older saved bundle) pair by position.
export function pairWithPrior(cyLines, pyLines) {
  const cy = asArray(cyLines);
  const py = asArray(pyLines);
  const keyed = cy.every((l) => l && l.key) && py.every((l) => l && l.key);
  if (!keyed) return cy.map((l, i) => ({ line: l, prior: py[i] }));
  const byKey = new Map(py.map((l) => [l.key, l]));
  const out = cy.map((l) => ({ line: l, prior: byKey.get(l.key) }));
  const seen = new Set(cy.map((l) => l.key));
  py.forEach((l) => { if (!seen.has(l.key)) out.push({ line: { ...l, amount: null }, prior: l }); });
  return out;
}

// item 20 (M58): interest income is taken as received in cash — said on screen when the chart has an interest receivable
export function InterestAssumedNote({ investing }) {
  const { t } = useI18n();
  if (!investing?.interest_assumed_received) return null;
  const accts = asArray(investing.interest_receivable_accounts).join(", ");
  return (
    <div className="border-b bg-amber-50 px-4 py-1.5 text-[11px] text-amber-800 dark:bg-amber-950/30 dark:text-amber-300"
         data-testid="cf-interest-assumed">
      {t("ifrs.cf.interestAssumed").replace("{accts}", accts)}
    </div>
  );
}
